<template>
	<div class="basic-instance-detail">
		<div class="jc-page-top">
			<div class="jc-colude-mask" v-if="descriptionFlag || nameFlag"></div>
			<div class="jc-page-header">
				<el-page-header show-back-icon :title="$t('detail.speechCraft.title')" @back="jump_to_up()"
					class="relative">
					<template slot="content">
						<span class="long-name" :title="hostName">
							{{ hostName }}
						</span>
						<div v-bind:class="hostStatusClass" class="jc-status-pl">
							<span class="icon-status icon-stopped icon-run"
								v-if='statusList.indexOf(hostStatus) <= -1'></span>
							{{ hostStatus }}
						</div>
						<!-- 帮助文档及操作 -->
						<div class="jc-list__header--right jc-box-action">
							<a :href="Config.CPS_HELP_URL" target="_blank">{{ $t('detail.speechCraft.helpDocument') }}</a>
							<drop-down-operation :buttonTitle="$t('privateNetInstance.operate')" :operations='ops'
								@clickSelectItem="clickOperate">
							</drop-down-operation>
						</div>
					</template>
				</el-page-header>
			</div>
			<div class="jc-page-content">
				<el-tabs ref="pageTabs" @tab-click="changeTab" v-model="tabName" type="border-card" :border-style="true"
					class="jc-list__header-tabs">
					<!-- tab:资源信息 -->
					<el-tab-pane :label="$t('privateNetInstance.sourceInfo')" name="sourceInfo"
						:disabled="tabName === 'sourceInfo'">
						<!-- 基本信息 -->
						<div class="jc-section">
							<div class="jc-section-header">
								<h3 class="jc-section-title">{{ $t('detail.text.baseInfo') }}</h3>
							</div>
							<div class="jc-section-content">
								<el-form class="jc-datashow-list jc-datashow-list-inline align-left" :model="editObj"
									ref="editObj" :rules="rules" @submit.native.prevent>
									<el-row :gutter="20">
										<!--ID-->
										<el-col :span="8">
											<el-form-item label="ID: ">
												<p>
													<span>{{ gridData.instanceId }}</span>
                          <copy-value :copyVal="`${gridData.instanceId}`"></copy-value>
													<!-- <span @mouseout="copyHover = false">
														<el-button :disabled="gridData.instanceId === undefined"
															v-clipboard:copy="instanceId"
															v-clipboard:success="copyToClipboard"
															v-clipboard:error="failToCopy" id="copy-button" type="text"
															icon="el-icon-document-copy"></el-button>
													</span> -->
												</p>
											</el-form-item>
										</el-col>
										<el-col :span="8" v-if='descriptionFlag'>
											<!--实例名称-->
											<el-form-item :label="$t('detail.text.name') | withColon"
												class="jc-form-description custom-detail-ellipsis">
												<p :title="gridData.name" class="instance-name">{{ gridData.name }}</p>
												<el-button type="text" icon="jc-icon-edit"
													@click="setEdit('name', gridData.name)"
													:disabled="gridData.name === undefined"></el-button>
											</el-form-item>
										</el-col>
										<el-col :span="8" v-if='!descriptionFlag'>
											<!--实例名称-->
											<el-form-item :label="$t('detail.text.name') | withColon"
												class="jc-form-description custom-detail-ellipsis" prop="editName"
												:show-message="false" ref="editName">
												<span :title="gridData.name" class="instance-name">{{ gridData.name
												}}</span>
												<el-button type="text" class="jc-icon-edit ml-4px p-0"
													@click="setEdit('name', gridData.name)"
													:disabled="gridData.name === undefined"></el-button>
												<div v-if="nameFlag" class="jc-info-description">
													<p class="txt">{{ $t('detail.text.modifyName') + ': ' }}</p>
													<el-input v-model="editObj.editName" class="jc-form-name-input"
														@keyup.enter.native="confirmModify('name')"
														:placeholder="$t('detail.placeholder.editName')"
														@focus="ruleFormTag.editName = 0" style="width: 300px;"></el-input>
													<p v-if="ruleFormTag.editName !== 0 && editObj.editName == ''"
														class="el-form-item-help-error">{{
															$t('detail.speechCraft.nameNoNull') }}</p>
													<p v-if="ruleFormTag.editName === 'error' && editObj.editName !== ''"
														class="el-form-item-help"
														:class="{ 'el-form-item-help-error': this.ruleFormTag.editName == 'error' }">
														{{ $t('create.help.instanceNameRule') }}</p>
													<div class="tright">
														<el-button @click="cancelDes">{{ $t('detail.text.cancel')
														}}</el-button>
														<el-button type="primary" @click="confirmModify('name')">{{
															$t('detail.text.sure') }}</el-button>
													</div>
												</div>
											</el-form-item>
										</el-col>
										<el-col :span="8" v-if='nameFlag'>
											<el-form-item :label="$t('detail.text.describe') | withColon"
												class="editdescription">
												<p class="icon-nowrap">
													<span v-if="gridData.description" :title="gridData.description"
														class="description">{{ gridData.description }} </span><el-button
														type="text" @click="setEdit('des', gridData.description)"
														class="icon-position jc-icon-edit ml-4px p-0"></el-button>
												</p>
											</el-form-item>
										</el-col>
										<el-col :span="8" v-if='!nameFlag'>
											<el-form-item :label="$t('detail.text.describe') | withColon"
												class="editdescription" :show-message="false" ref="editdescription"
												prop="editdescription">
												<p class="icon-nowrap"><span v-if="gridData.description"
														:title="gridData.description" class="description">{{
															gridData.description }} </span><el-button type="text"
														class="jc-icon-edit ml-4px p-0 icon-position"
														@click="setEdit('des', gridData.description)"></el-button></p>
												<div v-if="descriptionFlag" class="jc-info-description">
													<p class="txt">{{ $t('detail.text.modifyDescribe') + ': ' }}</p>
													<el-input @keyup.enter.native="confirmModify('des')" type="textarea"
														style="width: 338px;overflow: hidden;" :rows="4"
														v-model="editObj.editdescription" placeholder=""></el-input>
													<p v-if="ruleFormTag.editdescription == 'error'"
														class="el-form-item-help"
														:class="{ 'el-form-item-help-error': this.ruleFormTag.editdescription == 'error' }">
														{{ $t('detail.speechCraft.descriptionLongRule') }}</p>
													<div class="tright">
														<el-button @click="cancelDes">{{ $t('detail.text.cancel')
														}}</el-button>
														<el-button type="primary" @click="confirmModify('des')">{{
															$t('detail.text.sure') }}</el-button>
													</div>
												</div>
												<div class="jc-colude-mask" v-if="descriptionFlag"></div>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<!--计费类型-->
											<el-form-item :label="$t('detail.text.billingType') | withColon">
												<p v-if="gridData.chargeDesc">{{ gridData.chargeDesc }}</p>
												<p v-else>--</p>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<!--创建时间-->
											<el-form-item :label="$t('detail.text.createTime') | withColon">
												<p v-if="gridData.chargeStartTime">{{ gridData.chargeStartTime }}</p>
												<p v-else>--</p>
											</el-form-item>
										</el-col>
										<el-col :span="8"
											v-if="gridData.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION">
											<!--到期时间-->
											<el-form-item :label="$t('detail.text.expireTime') | withColon">
												<p v-if="gridData.chargeExpiredTime">{{ gridData.chargeExpiredTime }}</p>
												<p v-else>--</p>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<!--地域-->
											<el-form-item :label="$t('detail.text.region') | withColon">
												<p v-if="gridData.region">{{ regionMap[gridData.region] }}</p>
												<p v-else>--</p>
											</el-form-item>
										</el-col>
										<!--可用区-->
										<el-col :span="8">
											<!--可用区-->
											<el-form-item :label="$t('detail.text.availableArea') | withColon">
												<p v-if="gridData.az">{{ azMap[gridData.az] }}</p>
												<p v-else>--</p>
											</el-form-item>
										</el-col>
										<!--Agent状态-->
										<el-col :span="8">
											<agent-status :data="!parseInt(gridData.agentStatus, 10)" />
										</el-col>
										<!--标签-->
										<el-col :span="8">
											<!--标签-->
											<el-form-item :label="$t('listPage.text.tags') | withColon"
												class="custom-detail-ellipsis" :title="gridData.tagPairs | maybeEmpty">
												<p class="instance-name">{{ gridData.tagPairs | maybeEmpty }}</p>
											</el-form-item>
										</el-col>
										<!--实例删除保护-->
										<el-col :span="8">
											<el-form-item :label="$t('privateNetInstance.deleteProtect') | withColon">
												<span class="instance-name">
													{{ DeleteProtectStatusConstant[gridData.removeProtect] | maybeEmpty }}
												</span>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</div>
						</div>
						<el-divider></el-divider>
						<!-- 配置信息 -->
						<div class="jc-section">
							<div class="jc-section-header">
								<h3 class="jc-section-title">{{ $t('detail.text.configurationInfo') }}</h3>
							</div>
							<div class="jc-section-content">
								<el-form class="jc-datashow-list jc-datashow-list-inline">
									<el-row :gutter="20">
										<el-col :span="8">
											<!--镜像-->
											<el-form-item :label="$t('detail.text.mirroring') | withColon">
												<p>{{ gridData.osName | maybeEmpty }}</p>
											</el-form-item>
										</el-col>
										<!--规格-->
										<el-col :span="8">
											<el-form-item :label="$t('detail.text.spec') | withColon">
												<p class="instance-name" :title="gridData.standard">{{ gridData.standard |
													maybeEmpty }}</p>
											</el-form-item>
										</el-col>
										<!--CPU-->
										<el-col :span="8">
											<el-form-item :label="$t('create.text.cpu') | withColon">
												<p class="english-word-wrap">{{ gridData.formattedCpuDetail | maybeEmpty }}
												</p>
											</el-form-item>
										</el-col>
										<!--内存-->
										<el-col :span="8">
											<el-form-item :label="$t('create.text.memory') | withColon">
												<p class="english-word-wrap">{{ gridData.formattedMemDetail | maybeEmpty }}
												</p>
											</el-form-item>
										</el-col>
										<!--系统盘-->
										<el-col :span="8">
											<el-form-item :label="$t('detail.text.systemDisk') | withColon">
												<p>{{ gridData.osDisk | maybeEmpty }}</p>
											</el-form-item>
										</el-col>
										<!--数据盘-->
										<el-col :span="8">
											<el-form-item :label="$t('detail.text.dataDisk') | withColon">
												<p>{{ gridData.dataDisk | maybeEmpty }}</p>
											</el-form-item>
										</el-col>
										<!--GPU-->
										<el-col :span="8">
											<el-form-item :label="$t('create.text.gpu') | withColon">
												<p>{{ gridData.graphics | maybeEmpty }}</p>
											</el-form-item>
										</el-col>
										<!--登录密钥-->
										<el-col :span="8">
											<el-form-item :label="$t('privateNetInstance.loginKeyPair') | withColon">
												<span :title="gridData.keypairName" class="login-key">{{
													gridData.keypairName | maybeEmpty }}</span>
												<el-tooltip class="ml10" effect="dark" placement="right">
													<div slot="content">
														{{ $t('privateNetInstance.initPairTip') }}
													</div>
													<a><i class="jc-icon-question"></i></a>
												</el-tooltip>
											</el-form-item>
										</el-col>
										<!--SOS密钥-->
										<el-col :span="8">
											<el-form-item :label="$t('privateNetInstance.SOSKeyPair') | withColon">
												<span>
													{{ gridData.keypairNameSos | maybeEmpty }}
												</span>
												<el-tooltip class="ml10" effect="dark" placement="right">
													<div slot="content">
														{{ $t('privateNetInstance.sosKeyTip') }}
													</div>
													<a><i class="jc-icon-question"></i></a>
												</el-tooltip>
											</el-form-item>
										</el-col>
										<!--最近一次安装系统分区参数-->
										<el-col :span="24">
											<el-form-item :label="$t('create.text.lastCustomPartition') | withColon"
												class="customPartition">
												<span v-if="gridData.customSystemPartition">{{ $t('create.text.sysDisk')
												}}</span>
												<span v-if="gridData.customSystemPartition"
													v-html="gridData.customSystemPartition"></span>
												<span v-if="gridData.customDataPartition">{{ $t('create.text.dataDisk')
												}}</span>
												<span v-if="gridData.customDataPartition"
													v-html="gridData.customDataPartition"></span>
												<span
													v-if="!gridData.customSystemPartition && !gridData.customDataPartition">{{
														gridData.customSystemPartition
														| formatEmptyFilter }}</span>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</div>
						</div>
						<el-divider></el-divider>
						<!-- 网络信息 -->
						<div class="jc-section">
							<div class="jc-section-header">
								<h3 class="jc-section-title">{{ $t('detail.text.netInfo') }}</h3>
							</div>
							<div class="jc-section-content">
								<el-form class="jc-datashow-list jc-datashow-list-inline">
									<el-row :gutter="20">
										<el-col :span="8">
											<el-form-item :label="$t('listPage.text.priIpv4')">
												<p>{{ gridData.privateIp }}</p>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('detail.text.onetSegment') | withColon">
												<p>{{ subnetDetailData.cidr | maybeEmpty }}</p>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('privateNetInstance.outConsole') | withColon">
												<el-button type="text" @click="sosFix" :disabled="resetSosDisable">{{
													gridData.keypairIdSos !==
													undefined ? $t('privateNetInstance.operations.sos') :
													$t('privateNetInstance.operations.fixSOS') }}</el-button>
												<span v-if="gridData.keypairIdSos !== undefined">{{ '|' }}</span>
												<el-button v-if="gridData.keypairIdSos !== undefined" type="text"
													@click="sosReset" :disabled="resetSosDisable">{{
														$t('privateNetInstance.operations.resetSOS') }}</el-button>
												<el-tooltip class="ml10" effect="dark" placement="right">
													<div slot="content">
														{{ gridData.keypairIdSos !==
															undefined ? $t('privateNetInstance.sosTip') :
															$t('privateNetInstance.fixSOSTip') }}
													</div>
													<a><i class="jc-icon-question"></i></a>
												</el-tooltip>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('detail.text.firewall') | withColon"
												class="icon-nowrap">
												<p>{{ $t('detail.speechCraft.fireWallDefault') }}<a
														v-bind:href="Config.FIRE_HELP_URL" target="_blank"
														class="operate-link"><i class="jc-icon-enlarge"></i>{{
															$t('detail.text.operationsGuide') }}</a></p>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('listPage.text.pubIpv4')">
												<p v-if="gridData.publicIp">{{ gridData.publicIp }}</p>
												<p v-else>--</p>
											</el-form-item>
										</el-col>
										<el-col :span="8" v-if="gridData.enableIpv6 === 'yes'">
											<el-form-item :label="$t('listPage.text.pubIpv6')">
												<p v-if="gridData.publicIpv6 != undefined">{{ gridData.publicIpv6 }}</p>
												<p v-else>--</p>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item :label="$t('detail.text.publicNetBandWidth') | withColon">
												<p v-if="gridData.bandwidth">{{ gridData.bandwidth }}Mbps</p>
												<p v-else>--</p>
											</el-form-item>
										</el-col>
									</el-row>
								</el-form>
							</div>
						</div>
					</el-tab-pane>
					<!-- tab:硬件监控 -->
					<el-tab-pane :label="$t('privateNetInstance.hardWareMonitor')" name="hardWareMonitor"
						:disabled="tabName === 'hardWareMonitor'">
						<!-- 硬件设备状态 -->
						<div class="jc-section">
							<div class="jc-section-header">
								<h3 class="jc-section-title">{{ $t('detail.text.hardwareStatus') }}</h3>
							</div>
							<div class="jc-section-content">
								<hardware-status :hardWareData="hardWareData"></hardware-status>
							</div>
						</div>
						<!-- 报警日志列表 -->
						<div class="jc-section mt20">
							<div class="jc-section-header">
								<h3 class="jc-section-title">{{ $t('detail.text.warningLogList') }}</h3>
							</div>
							<div class="jc-section-content">
								<alarm-logs :eventLogs="eventLogs"></alarm-logs>
							</div>
						</div>
						<div ref="footer" class="jc-page-footer-detail" v-if="total">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper" :total="total">
							</el-pagination>
						</div>
					</el-tab-pane>
					<!-- tab:性能监控 -->
					<el-tab-pane :label="$t('detail.text.performanceMonitor')" name="performanceMonitor"
						:disabled="tabName === 'performanceMonitor'">
						<div class="jc-section">
							<router-view v-if="hasMonitor"></router-view>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<div id="public_net">
			<el-dialog :title="$t('detail.speechCraft.adjustPubNetBand')" :visible.sync="public_net_dialog_visible"
				size="default" :close-on-click-modal="false" @close="resetInitParams()">
				<div class="i-text">
					<div class="tip-warning">
						{{ $t('detail.speechCraft.publicNetTip') }}
					</div>
				</div>
				<el-form ref="form" label-width="80px" style="margin-top:20px" onsubmit="return false">
					<el-form-item :label="$t('detail.text.maxBandWidth') | withColon">
						<div class="block">
							<div class="el-form-item-inline">
								<el-slider v-model="public_net_slider_value" show-input @change="calPrice()" :max="200"
									:debounce="1000" :marks="marks" :min="minBandwidth" class="jc-slider-custom">
								</el-slider>
							</div>
						</div>
					</el-form-item>
				</el-form>

				<el-table :data="public_net_gridData" class="mt20 mb40">
					<el-table-column property="name" :label="$t('detail.text.name')" width="110">
						<template slot-scope="scope">
							<el-tooltip class="item" effect="dark" :content="scope.row.name" placement="bottom">
								<span class="custom-ellipsis">{{ scope.row.name }}</span>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column property="public_ip" :label="$t('detail.text.publicNetIP')" width='160'>
						<template slot-scope="scope">
							<p style="margin-bottom:0px" v-if="scope.row.public_ip"
								:title="scope.row.public_ip + $t('listPage.text.publicIpv4')">
								{{ scope.row.public_ip }}{{ $t('listPage.text.publicIpv4') }}</p>
							<p v-else>--{{ $t('listPage.text.publicIpv4') }}</p>
							<el-tooltip
								v-if="scope.row.enableIpv6 === 'yes' && scope.row.public_ipv6 != undefined && scope.row.public_ipv6 != ''"
								class="item" effect="dark" :content="scope.row.public_ipv6 + $t('listPage.text.publicIpv6')"
								placement="bottom">
								<span>{{ scope.row.public_ipv6 }}{{ $t('listPage.text.publicIpv6') }}</span>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column property="expire_date" :label="$t('detail.text.expireTime')"
						width='150'></el-table-column>
					<el-table-column property="current_bandwidth"
						:label="$t('detail.text.currentBandWidth')"></el-table-column>
					<el-table-column property="charge" :label="$t('detail.text.billingMethods')"></el-table-column>
				</el-table>

				<span>{{ $t('detail.text.cost') | withColon }}</span><span class="cFAB418 fz24">{{ totalFee }}</span>
				<p v-if="totalDiscount !== '0.00' && totalDiscount !== '0' && totalDiscount !== 0">
					<span class="price" style="font-size:10px;text-decoration:line-through;">{{ $t('detail.text.price') +
						$t('detail.text.currencySymbol') + ': ' + totalPrice }}</span>
					<span class="ml20 cff96">{{ $t('detail.text.saving') + $t('detail.text.currencySymbol') + ': ' +
						totalDiscount }}</span>
				</p>
				<span slot="footer" class="dialog-footer">
					<el-button @click="public_net_dialog_visible = false">{{ $t('detail.text.cancel') }}</el-button>
					<el-button type="primary" @click="public_net_confirm()"
						:disabled="public_net_slider_value <= minBandwidth || public_net_slider_value > 200 || isNaN(public_net_slider_value)">{{
							$t('detail.text.sure') }}</el-button>
				</span>
			</el-dialog>
		</div>
		<div v-if="copyHover" class="jc-tooltip__popper is-dark"
			style="position: absolute; top: 180px; left: 262px; transform-origin: center top 0px; z-index: 2000;"
			x-placement="bottom">{{ $t('detail.text.copySuccess') }}<div x-arrow="" class="popper__arrow"
				style="left: 29px;"></div>
		</div>
		<reset-password :dialogVisible.sync="resetPasswordDialogVisible" :detail-data="gridData"
			@refreshData="getServerData('refresh')">
		</reset-password>
		<jcb-opt-protect :visible.sync="operationProtectVisible" :action-type="actionType" @success="onSuccess"
			@error="onError">
		</jcb-opt-protect>
		<have-sos :visible.sync="sosShow" :rowInfo="gridData" @refresh="getServerData('refresh')">
		</have-sos>
		<reset-sos :visible.sync="resetSOSShow" :rowInfo="gridData" @refresh="getServerData('refresh')">
		</reset-sos>
		<fix-sos :visible.sync="fixSOSShow" :rowInfo="gridData" @refresh="getServerData('refresh')">
		</fix-sos>
		<!--重装系统弹框-->
		<reinstall :visible.sync="sys_rein_dialog_visible" :rowInfo="gridData" @openReConfirm="openReConfirm"
			v-if="sys_rein_dialog_visible">
		</reinstall>
		<!--重装系统二次确认弹框-->
		<resys :visible.sync="sys_rein_confirm_dialog_visible" :formInfo="reSysForm" :rowInfo="reSystemInfo"
			@refresh="getServerData('refresh')" v-if="sys_rein_confirm_dialog_visible">
		</resys>
		<!--编辑标签-->
		<jcb-tag-edit :visible.sync="editTagDialogVisible" :service-code="ServiceCodeConstant.CPS"
			:region-id="gridData.region !== undefined ? gridData.region : ''"
			:resource-ids="gridData.instanceId !== undefined ? [gridData.instanceId] : []" @complete="updateServerData">
		</jcb-tag-edit>
		<!--删除实例-->
		<delete-instance :visible.sync="deleteVisible" :rowInfo="gridData" :pageSource="'detail'" @goList="jump_to_up()"
			@refresh="getServerData('refresh')">
		</delete-instance>
		<!--开启实例删除操作保护-->
		<enable-deletion-protection :visible.sync="enableDeletionProtectionVisible" :instanceName="gridData.name"
			:region="gridData.region" :instanceId="gridData.instanceId" @refresh="getServerData('refresh')">
		</enable-deletion-protection>
		<!--关闭实例删除操作保护-->
		<disable-deletion-protection :visible.sync="disableDeletionProtectionVisible" :instanceName="gridData.name"
			:region="gridData.region" :instanceId="gridData.instanceId" @refresh="getServerData('refresh')">
		</disable-deletion-protection>
	</div>
</template>

<script>
import {
	PopStatus,
	OperationConstant,
	PasswordRuleConstant,
	OverdueConstantArray,
	ServiceCodeConstant,
	CreateTypeConstant,
	ChargeModeConstant,
	DeleteProtectStatusConstant
} from '@/common/Constants';
import ResetPassword from '@/components/common/resetPassword/ResetPassword';
import operationProtect from '@/mixins/operationProject';
import loginMethods from '@/components/common/loginMethods/LoginMethods';
import CustomData from '@/components/common/customData/CustomData';
import AgentStatus from '@/components/privateNetInstance/AgentStatus';
import DeleteInstance from '@/components/common/DeleteInstance';
import HaveSos from '@/components/common/HaveSos';
import FixSos from '@/components/common/FixSos';
import ResetSos from '@/components/common/ResetSos';
import reinstall from '@/components/privateNetInstance/operates/ReSystem';
import resys from '@/components/privateNetInstance/operates/ReSysConfirm';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import EnableDeletionProtection from '@/components/common/enableDeletionProtection/EnableDeletionProtection';
import DisableDeletionProtection from '@/components/common/disableDeletionProtection/DisableDeletionProtection';
import HardwareStatus from '@/components/common/hardwareStatus/HardwareStatus';
import AlarmLogs from '@/components/common/alarmLogs/AlarmLogs';
import copyValue from '@/components/privateNetwork/CopyValue';
const initPage = 1;

export default {
	components: {
		ResetPassword,
		AgentStatus,
		loginMethods,
		CustomData,
		DeleteInstance,
		reinstall,
		resys,
		HaveSos,
		FixSos,
		ResetSos,
		dropDownOperation,
		EnableDeletionProtection,
		DisableDeletionProtection,
		HardwareStatus,
		AlarmLogs,
    copyValue
	},
	mixins: [operationProtect],
	data() {
		const validatePassword = (rule, value, callback) => {
			var rule = PasswordRuleConstant;
			const result = rule.test(value);
			if (!result) {
				callback(new Error(this.$t('detail.errorMessage.passwordRule[0]')));
				return;
			}
			callback();
		};

		const validateConfirmPassword = (rule, value, callback) => {
			if (value == '') {
				callback(new Error(this.$t('detail.errorMessage.passwordRule[0]')));
			} else if (value != this.sys_rein_form.password) {
				callback(new Error(this.$t('detail.errorMessage.passwordRule[1]')));
			} else {
				callback();
			}
		};

		const validateLength = (rule, value, callback) => {
			if (value.length > 256) {
				callback(new Error());
			} else {
				callback();
			}
		};

		// 验证实例名称
		const validateName = (rule, value, callback) => {
			const reg = new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:]{1,127})$');
			if (!reg.test(value)) {
				callback(new Error());
			} else {
				callback();
			}
		};

		// 验证主机名
		const validatehostName = (rule, value, callback) => {
			if (value === '') {
				callback();
			}
			const hostRule = /(^((?!(^-)|(-$)|(--+)|(^\\.)|(\\.$)|(\\.\\.+))[0-9A-Za-z-.]){2,64}$)|(^\s*$)/;
			if (!hostRule.test(value)) {
				this.ruleFormTag.hostname = 'false';
				callback(new Error());
			} else {
				this.ruleFormTag.hostname = 'true';
				callback();
			}
		};

		return {
			advancedSetting: false, // 高级设置开关(重装使用)
			userData: '', // 高级设置脚本内容，已base64过(重装使用)
			clientToken: Normal.getClientToken(),
			instanceId: '',
			region: '',
			tabName: '',
			hostName: '',
			hostStatus: '',
			hostStatusClass: '',
			statusMap: {
				'starting': this.$t('detail.text.powerIn'),
				'running': this.$t('detail.text.run'),
				'stopping': this.$t('detail.text.shuttingDown'),
				'stopped': this.$t('detail.text.shutdown'),
				'error': this.$t('detail.text.error'),
				'restarting': this.$t('detail.text.rebooting'),
				'creating': this.$t('detail.text.creating'),
				'destroying': this.$t('detail.text.destroying'),
				'upgrading': this.$t('detail.text.reconfiging'),
				'reinstalling': this.$t('detail.text.reinstalling'),
				'resetting_password': this.$t('listPage.text.resettingPassword'),
			},
			centerStatus: ['reinstalling', 'upgrading', 'destroying', 'creating', 'restarting', 'stopping', 'starting'],
			statusList: [this.$t('detail.text.run'), this.$t('detail.text.shutdown'), this.$t('detail.text.error')],
			statusClassMap: {// 这个想想怎么改
				'shutdown': 'jc-status-warning',
				'run': 'jc-status-success',
				'intermediate': ' my-status my-status-middle ',
				'error': 'jc-status-danger'
			},
			// 临时解决方案
			convertStatus: {
				'shutdown': ''
			},
			// 数据盘提示列表
			raidsNameMap: {
				NORAID: 'NO RAID',
				RAID0: 'RAID0',
				RAID1: 'RAID1',
				RAID10: 'RAID10',
				RAID5: 'RAID5',
				RAID51H: 'RAID 5+1 hotspare+NO RAID'
			},
			customRaidsNameMap: {
				RAID51H: 'RAID 5+1 hotspare',
				NORAID: 'NO RAID'
			},
			operatesShowArr: [],
			chargeModeMap: {
				prepaid_by_duration: this.$t('detail.text.prepaid_by_duration'),
				postpaid_by_duration: this.$t('listPage.text.postpaid_by_duration'),
			},
			selectOperate: '1',
			gridData: {},
			// dialog公网
			public_net_dialog_visible: false,
			public_net_slider_value: 0,
			public_net_gridData: [],
			// 重装系统
			sys_rein_dialog_visible: false,
			sys_rein_confirm_dialog_visible: false,
			sys_rein_gridData: [{
				name: ''
			}],
			descriptionFlag: false,

			editObj: {
				editName: '',
				editdescription: ''
			},

			nameFlag: false,
			// 废弃的字段
			// sys_rein_radio: '当前镜像',
			sys_rein_form: {
				mirror: '',
				admin: 'root',
				password: '',
				disk: false,
				delivery: false,
				type: [],
				systemType: this.selectedOSTypeId,
				resource: '',
				desc: '',
				application: this.selectedApplication,
				hostname: '',
			},
			totalFee: 0,
			totalDiscount: 0,
			totalPrice: 0,
			minBandwidth: 0,
			rules: {
				password: [
					{ validator: validatePassword, trigger: 'blur' }
				],
				confirmPassword: [
					{ validator: validateConfirmPassword, trigger: 'blur' }
				],
				editName: [
					// {type:'string',pattern:new RegExp('^[-0-9a-zA-Z_\\u4e00-\\u9fa5]{1,32}$'),trigger:'blur'}
					{ validator: validateName }
				],
				editdescription: [
					// {type:'string',pattern:new RegExp('^.{0,256}$'),trigger:'blur'}
					{ validator: validateLength }
				],
				hostname: [
					{
						validator: validatehostName,
						trigger: 'blur'
					}
				]
			},
			timer: [],
			intervalTime: 5000, // 定时器时间
			imageTypes: { 'standard': this.$t('detail.text.standardImage') },
			osTypes: {},
			standardOsTypes: {},
			customOsTypes: {},
			resetSosDisable: false,
			selectedImageType: 'standard',
			initImageType: '',
			selectedOS: '',
			selectedOSTypeId: '',
			selectedOSVersion: '',
			applications: [],
			ops: [],

			applicationsExtend: {
				'Nginx': {
					class: 'my-nginx',
					tooltip: this.$t('detail.speechCraft.applicationTooltips.Nginx')
				},
				'MySQL': {
					class: 'my-mysql',
					tooltip: this.$t('detail.speechCraft.applicationTooltips.MySQL')
				},
				'RabbitMQ': {
					class: 'my-rabbitmq',
					tooltip: this.$t('detail.speechCraft.applicationTooltips.RabbitMQ')
				},
			},
			selectedApplication: [],
			raids: [],
			selectedOSRaidId: '',
			selectedDataRaidId: '',
			ruleFormTag: {
				password: 0,
				confirmPassword: 0,
				application: 0,
				editName: 0,
				editdescription: 0,
				hostname: 'true'
			},
			hardWareData: [],
			chargeStatus: '',
			region: '',
			bandwidthTip: '',
			regionMap:
			{
				'cn-east-1': this.$t('detail.text["cn-east-1"]'),
				'cn-north-1': this.$t('detail.text["cn-north-1"]'),
			},
			azMap: {
				'cn-east-1a': this.$t('detail.text["cn-east-1a"]'),
				'cn-north-1b': this.$t('detail.text["cn-north-1b"]'),
				'cn-north-1a': this.$t('detail.text["cn-north-1a"]')
			},
			copyHover: false,
			// 代替代码中'中间态'
			intermediate: this.$t('detail.text.intermediate'),
			// 代替代码中'错误'字段
			error: this.$t('detail.text.error'),
			// 监控日志数据
			eventLogs: [],
			pageSize: 20,
			pageSizes: [20, 50, 100], // 可选每页展示多少条
			total: 0,
			currentPage: initPage,
			loading: false,
			activeTab: 'source',
			// 重装密码弹框是否可见
			resetPasswordDialogVisible: false,
			// 重装系统二次确认的checkbox
			reinstallConfirmChecked: false,
			// 选择的数据盘Type
			selectedDataRaidType: '',
			// 给操作保护用区分物理机类型：basic/vpc
			instanceType: 'basic',
			subnetDetailData: {},
			// 编辑标签组件是否显示
			editTagDialogVisible: false,
			// 批量编辑标签组件是否显示
			batchEditTagDialogVisible: true,
			// 删除实例弹框
			deleteVisible: false,
			sosShow: false,
			fixSOSShow: false,
			resetSOSShow: false,
			sosTip: '',
			hasMonitor: false,
			//带宽上限的上限和下限
			marks: { [this.minBandwidth]: '1Mbps', 200: '200Mbps' },
			operateMap: {
				stopped: [
					'restart'
				],
				running: [
					'reinstall',
					'resetPassword',
					'delete'
				],
				error: [
					'start',
					'turnOff',
					'restart',
					'resetPassword',
					'reinstall',
					'bandWidth',
					'renew',
					'editTag',
					'delete',
					'turnOnDeleteProtect',
					'turnOffDeleteProtect',
					'ipv6',
				],
				creating: [
					'start',
					'turnOff',
					'restart',
					'resetPassword',
					'reinstall',
					'bandWidth',
					'renew',
					'editTag',
					'turnOnDeleteProtect',
					'turnOffDeleteProtect',
					'delete',
					'sos',
					'ipv6',
				],
				upgrading: [
					'start',
					'turnOff',
					'restart',
					'resetPassword',
					'reinstall',
					'bandWidth',
					'renew',
					'editTag',
					'turnOnDeleteProtect',
					'turnOffDeleteProtect',
					'delete',
					'ipv6',
				],
				destroying: [
					'start',
					'turnOff',
					'restart',
					'resetPassword',
					'reinstall',
					'bandWidth',
					'renew',
					'editTag',
					'turnOnDeleteProtect',
					'turnOffDeleteProtect',
					'delete',
					'ipv6',
				],
				other: [
					'start',
					'turnOff',
					'restart',
					'resetPassword',
					'reinstall',
					'bandWidth',
					'editTag',
					// 'renew'
					'turnOnDeleteProtect',
					'turnOffDeleteProtect',
					'delete',
					'ipv6',
				],
				noOperate: [
					'starting',
					'running',
					'stopping',
					'stopped',
					'error',
					'restarting',
					'creating',
					'destroying',
					'upgrading',
					'reinstalling',
					'turnOnDeleteProtect',
					'turnOffDeleteProtect',
					'delete',
					'ipv6',
				]
			},
			statusListMap: {
				'starting': 'other',
				'running': 'running',
				'stopping': 'other',
				'stopped': 'stopped',
				'error': 'error',
				'restarting': 'other',
				'creating': 'creating',
				'destroying': 'destroying',
				'upgrading': 'upgrading',
				'reinstalling': 'other',
				'noOprate': 'noOperate',
				'other': 'other',
				'resetting_password': 'other',
			},
			interStatus: [
				'creating',
				'starting',
				'stopping',
				'restarting',
				'upgrading',
				'reinstalling',
				'destroying',
				'resetting_password'
			],
			statusMapName: {
				'creating': this.$t('privateNetInstance.statueNames.creating'),
				'starting': this.$t('privateNetInstance.statueNames.starting'),
				'running': this.$t('privateNetInstance.statueNames.running'),
				'stopping': this.$t('privateNetInstance.statueNames.stopping'),
				'stopped': this.$t('privateNetInstance.statueNames.stopped'),
				'restarting': this.$t('privateNetInstance.statueNames.restarting'),
				'error': this.$t('privateNetInstance.statueNames.error'),
				'upgrading': this.$t('privateNetInstance.statueNames.upgrading'),
				'reinstalling': this.$t('privateNetInstance.statueNames.reinstalling'),
				'destroying': this.$t('privateNetInstance.statueNames.destroying'),
				'resetting_password': this.$t('listPage.text.resettingPassword'),
			},
			// 开启实例删除操作保护弹框
			enableDeletionProtectionVisible: false,
			// 关闭实例删除操作保护弹框
			disableDeletionProtectionVisible: false,
		};
	},
	computed: {
		ServiceCodeConstant: () => ServiceCodeConstant,
		OperationConstant: () => OperationConstant,
		ChargeModeConstant: () => ChargeModeConstant,
		OverdueConstantArray: () => OverdueConstantArray,
		DeleteProtectStatusConstant: () => DeleteProtectStatusConstant
	},
	watch: {
		// 切换操作系统类型，清空操作系统版本
		selectedOS() {
			this.selectedOSTypeId = '';
		},
		selectedOSTypeId(newValue, oldVlue) {
			if (newValue == '') {
				this.applications = [];
			}
			this.sys_rein_form.systemType = newValue;
			this.selectedApplication = [];
		},
		selectedImageType(newValue, oldVlue) {
			if (newValue !== 'standard_app') {
				this.osTypes = $.extend(true, {}, this.standardOsTypes);
			} else {
				this.selectedOS = 'CentOS';
				this.osTypes = $.extend(true, {}, this.customOsTypes);
			}
			if (newValue == 'standard_app' && this.selectedRegion && this.selectedOS === 'CentOS') {
			}
			this.selectedOSTypeId = '';
			this.selectedApplication = [];
		},
		selectedApplication(newValue, oldVlue) {
			this.sys_rein_form.application = newValue;
			if (newValue.length) {
				this.ruleFormTag.application = 0;
			}
		}
	},
	mounted() {
		this.instanceId = this.$route.params.id;
		this.region = this.$route.params.region;
		this.az = this.$route.params.az;
		this.tabName = this.$route.query.tabName;
		this.getServerData(true);
		if (this.tabName === 'performanceMonitor') {
			this.hasMonitor = true;
		}
	},
	beforeRouteLeave(to, from, next) {
		this.clearTimer();
		next();
	},
	methods: {
		/**
			 * 点击跳转初始密钥详情
			 * @param keypairId
			 * @param region
			 */
		jumpToKeyPairDetail(keypairId, region) {
			this.$router.push(
				{
					path: '/ssh/detail',
					query: {
						id: keypairId,
						region
					}
				}
			);
		},
		clearTimer() {
			if (this.timer.length > 0) {
				for (let i = 0; i < this.timer.length; i++) {
					clearTimeout(this.timer[i]);
				}
			}
		},
		refreshData() {
			this.getServerData(true);
		},
		resetInitParams() {
			this.public_net_slider_value = this.minBandwidth;
			this.totalFee = 0;
			this.totalDiscount = 0;
			this.totalPrice = 0;
		},
		setEdit(type, data) {
			if (type === 'name') {
				this.nameFlag = true;
				this.ruleFormTag.editName = 0;
				this.editObj.editName = data;
				setTimeout(() => {
					try {
						$('.jc-form-name-input input').focus();
					} catch (e) { }
				}, 200);
			} else {
				this.descriptionFlag = true;
				this.ruleFormTag.editdescription = 0;
				this.editObj.editdescription = $.trim(data);
			}
		},
		cancelDes() {
			this.editObj.editName = '';
			this.editObj.editdescription = '';
			this.descriptionFlag = false;
			this.nameFlag = false;
			if (this.$refs.editdescription != undefined) {
				this.$refs.editdescription.resetField();
			}
			if (this.$refs.editName != undefined) {
				this.$refs.editName.resetField();
			}
		},
		/**
			 * 用于修改某个信息项，弹出对话框并确认
			 * @param {string} type - 信息项对应的类别
			 */
		confirmModify(type) {
			this.$refs.editObj.validate(async (valid) => {
				// validate fail
				if (!valid) {
					if (type === 'name' && this.$refs.editName.validateState === 'error') {
						this.ruleFormTag.editName = this.$refs.editName.validateState;
						return;
					}
					if (type === 'des' && this.$refs.editdescription.validateState === 'error') {
						this.ruleFormTag.editdescription = this.$refs.editdescription.validateState;
						return;
					}
				}
				// validate succ
				switch (type) {
					case 'name': // 修改 实例名称
						if (this.editObj.editName === this.gridData.name) {
							this.nameFlag = false;
							return;
						}
						const nameRes = await Ajax.post('/api/cps/modifyInstanceName', {
							instanceId: this.gridData.instanceId,
							region: this.gridData.region,
							name: this.editObj.editName
						}).catch(async (err) => {
							const { response } = err.data;
							try {
								const json = await response.json();
								this.$message.error(json.errmsg);
							} catch (ex) {
								console.log(ex);
							}
						});
						this.hostName = this.gridData.name = nameRes.data.name;
						this.nameFlag = false;
						break;
					case 'des': // 修改 描述
					default:
						if (this.editObj.editdescription === this.gridData.description) {
							this.descriptionFlag = false;
							return;
						}
						const desRes = await Ajax.post('/api/cps/modifyInstanceDescription', {
							instanceId: this.gridData.instanceId,
							region: this.gridData.region,
							description: this.editObj.editdescription
						});
						this.gridData.description = desRes.data.description;
						this.descriptionFlag = false;
						break;
				}
				if (typeof this.$refs.editdescription !== 'undefined') {
					this.$refs.editdescription.resetField();
				}
			});
		}, // end of confirmModify
		getServerData(initOperate = false) {
			const target = this;
			const params = {
				region: target.region,
				instanceId: target.instanceId,
				az: target.az,
			};
			Ajax.get('/api/cps/getInstanceInfo', params).then((res) => {
				const data = res.data;
				target.gridData = data.instance;
				target.gridData.chargeMode = target.gridData.charge.chargeMode;
				target.hostName = target.gridData.name;
				target.hostStatus = target.intermediate;
				target.region = target.gridData.region;
				this.sn = this.gridData.sn;
				// 格式化标签键值对
				const tagPairs = res.data.instance.tags;
				// target.gridData.status = "Stopped";
				if (target.statusMap[target.gridData.status]) {
					target.hostStatus = target.statusMap[target.gridData.status];
				}
				if (target.statusList.indexOf(target.hostStatus) > -1) {
					target.hostStatusClass = target.statusClassMap[this.transformKey(target.hostStatus)];
				} else {
					target.hostStatusClass = target.statusClassMap.intermediate;
				}
				target.clearTimer();
				if (target.centerStatus.indexOf(data.instance.status) > -1) {
					target.timer.push(setTimeout(target.refreshData, target.intervalTime));
				}
				// 格式化下
				target.gridData.chargeStartTime = target.gridData.charge.chargeStartTime;
				target.gridData.chargeExpiredTime = target.gridData.charge.chargeExpiredTime;
				target.gridData.chargeDesc = target.chargeModeMap[target.gridData.charge.chargeMode];

				target.gridData.standard = target.gridData.spec;
				target.gridData.osDisk = target.gridData.systemDiskDesc;
				target.chargeStatus = target.gridData.charge.chargeStatus;
				// 登录密钥对特殊处理
				target.gridData.keypairName = target.gridData.keypairName && target.gridData.keypairName.join(' | ');
				// 格式化标签字段
				target.gridData.tagPairs = '';
				if (tagPairs !== undefined) {
					if (tagPairs.length > 0) {
						for (const tag of tagPairs) {
							target.gridData.tagPairs += `${tag.key}:${tag.value},`;
						}
						target.gridData.tagPairs = target.gridData.tagPairs.substring(0, target.gridData.tagPairs.length - 1);
					}
				}
				if (target.gridData.dataRaidType == 'NORAID') {
					target.gridData.dataDisk = target.gridData.dataDiskDesc.replace(/NORAID/, 'NO RAID');
				} else {
					target.gridData.dataDisk = target.gridData.dataDiskDesc;
				}
				// 格式化显示信息
				const cpsDeviceDetail = data.instance.cpsConfiguration.deviceType;
				// GPU
				target.gridData.graphics = cpsDeviceDetail.gpuConcise ? cpsDeviceDetail.gpuConcise : '';
				// CPU
				target.gridData.formattedCpuDetail = cpsDeviceDetail ? cpsDeviceDetail.cpuDetail : '';
				// MEMORY
				target.gridData.formattedMemDetail = cpsDeviceDetail ? cpsDeviceDetail.memDetail : '';
				this.dealCustomPartition(this.gridData.customPartition);
				target.ops = target.initOperations(target.gridData);
			}).catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					target.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			}).finally(() => {
			});
			this.getSubnetDetailData();
		},

		// 最近一次安装系统分区参数处理
		dealCustomPartition(customPartition) {
			let customSystemPartition = this.partitionsFormatter(customPartition.systemDiskPartitions);
			let customDataPartition = this.partitionsFormatter(customPartition.dataDiskPartitions);
			this.gridData.customSystemPartition = customSystemPartition;
			this.gridData.customDataPartition = customDataPartition;
		},

		// 格式化分区信息
		partitionsFormatter(partitions) {
			return partitions.reduce((init, current) => {
				let size;
				if (current.size === 999999999) {
					size = this.$t('retailInstance.text.allRemainingSpace');
				} else {
					size = current.size / 1024 + 'GiB';
				}
				return `${init}<strong class="ml5 mr5">${current.point}:</strong>${size},${current.format};`
			}, '');
		},
		initOperations() {
			const item = this.gridData;
			const operations = [
				{
					operateName: this.$t('privateNetInstance.restart'),
					disabled: !item.charge.chargeStatus || OverdueConstantArray.includes(item.charge.chargeStatus)
						|| this.operateMap[this.statusListMap[item.status]].indexOf('restart') > -1,
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.$t('privateNetInstance.operations.onlyRunning'),
					value: 'restart'
				},
				{
					operateName: this.$t('privateNetInstance.operations.rePassword'),
					disabled: !item.charge.chargeStatus || this.operateMap[this.statusListMap[item.status]].indexOf('resetPassword') !== -1
						|| OverdueConstantArray.includes(item.charge.chargeStatus),
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.$t('privateNetInstance.operations.onlyShutDown'),
					value: 'rePassword'
				},
				{
					operateName: this.$t('privateNetInstance.operations.reOperateSystem'),
					disabled: !item.charge.chargeStatus || this.operateMap[this.statusListMap[item.status]].indexOf('reinstall') > -1
						|| OverdueConstantArray.includes(item.charge.chargeStatus),
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.$t('privateNetInstance.operations.onlyShutDown'),
					value: 'reInstall'
				},
				{
					operateName: this.$t('operations.bandwidth.name'),
					disabled: this.operateMap[this.statusListMap[item.status]].indexOf('bandWidth') > -1
						|| OverdueConstantArray.includes(item.charge.chargeStatus)
						|| !item.publicIp
						|| typeof item.charge.chargeStatus === 'undefined',
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.bandwidthTip,
					value: 'bandwidth'
				},
				{
					operateName: this.$t('privateNetInstance.operations.repay'),
					disabled: this.operateMap[this.statusListMap[item.status]].indexOf('renew') > -1
						|| item.charge.chargeStatus === undefined,
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : '',
					value: 'repay'
				}
			];
			if (item.status === 'stopped') {
				operations.splice(0, 0, {
					operateName: this.$t('privateNetInstance.open'),
					disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
						|| this.operateMap[this.statusListMap[item.status]].indexOf('start') > -1
						|| !item.charge.chargeStatus,
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.$t('privateNetInstance.operations.onlyShutDown'),
					value: 'open'
				});
			} else {
				operations.splice(0, 0, {
					operateName: this.$t('privateNetInstance.shutdown'),
					disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
						|| this.operateMap[this.statusListMap[item.status]].indexOf('turnOff') > -1
						|| !item.charge.chargeStatus,
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.$t('privateNetInstance.operations.onlyRunning'),
					value: 'close'
				});
			}
			//调整公网带宽
			if (!item.charge.chargeStatus) {
				this.bandwidthTip = this.$t('eip.help.noChargeInfo');
			}
			else if (item.publicIp) {
				this.bandwidthTip = this.$t('operations.bandwidth.tip');
			} else {
				this.bandwidthTip = this.$t('operations.bandwidth.tip_public_ip');
			};
			if (!item.charge.chargeStatus) {
				this.sosTip = this.$t('eip.help.noChargeInfo');
			}
			else if (item.imageType === 'Windows') {
				this.sosTip = this.$t('privateNetInstance.operations.notWindows');
			} else {
				this.sosTip = '';
			};
			if (item.keypairIdSos !== undefined) {
				//SOS
				operations.splice(5, 0, {
					operateName: this.$t('privateNetInstance.operations.sos'),
					disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
						|| item.imageType === 'Windows'
						|| !item.charge.chargeStatus,
					tip: this.sosTip,
					value: 'sos'
				});
				//重置SOS
				operations.splice(6, 0, {
					operateName: this.$t('privateNetInstance.operations.resetSOS'),
					disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
						|| item.imageType === 'Windows'
						|| !item.charge.chargeStatus,
					tip: this.sosTip,
					value: 'resetSos'
				});
				this.resetSosDisable = item.imageType === 'Windows' || OverdueConstantArray.includes(item.charge.chargeStatus) || !item.charge.chargeStatus
			} else {
				// 修复SOS
				operations.splice(5, 0, {
					operateName: this.$t('privateNetInstance.operations.fixSOS'),
					disabled: OverdueConstantArray.includes(item.charge.chargeStatus)
						|| item.imageType === 'Windows'
						|| !item.charge.chargeStatus,
					tip: this.sosTip,
					value: 'fixSos'
				});
				this.resetSosDisable = item.imageType === 'Windows' || OverdueConstantArray.includes(item.charge.chargeStatus) || !item.charge.chargeStatus
			};
			// 编辑标签
			operations.push({
				operateName: this.$t('operations.edit_tag.name'),
				disabled: this.operateMap[this.statusListMap[item.status]].indexOf('editTag') > -1
					|| OverdueConstantArray.includes(item.charge.chargeStatus)
					|| typeof item.charge.chargeStatus === 'undefined',
				tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.$t('operations.edit_tag.tip'),
				value: 'editTag'
			});
			// 开启实例删除保护
			if (item.removeProtect === 'no') {
				const turnOnDeleteProtect = {
					operateName: this.$t('operations.turnOnDeleteProtect.name'),
					disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
						|| typeof item.charge.chargeStatus === 'undefined'
						|| this.operateMap[this.statusListMap[item.status]].indexOf('turnOnDeleteProtect') > -1
						|| this.OverdueConstantArray.includes(item.chargeStatus),
					value: 'turnOnDeleteProtect',
					tip: ''
				};
				if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
					turnOnDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.prepaidTip');
				}
				if (this.OverdueConstantArray.includes(item.chargeStatus)) {
					turnOnDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.tip');
				}
				if (!item.charge.chargeStatus) {
					turnOnDeleteProtect.tip = this.$t('eip.help.noChargeInfo');
				}
				operations.push(turnOnDeleteProtect);
			}
			if (item.removeProtect === 'yes') {
				// 关闭实例删除保护
				const turnOffDeleteProtect = {
					operateName: this.$t('operations.turnOffDeleteProtect.name'),
					disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
						|| typeof item.charge.chargeStatus === 'undefined'
						|| this.operateMap[this.statusListMap[item.status]].indexOf('turnOffDeleteProtect') > -1
						|| this.OverdueConstantArray.includes(item.chargeStatus),
					value: 'turnOffDeleteProtect',
					tip: ''
				};
				if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
					turnOffDeleteProtect.tip = this.$t('operations.delete.tip')
				}
				if (this.OverdueConstantArray.includes(item.chargeStatus)) {
					turnOffDeleteProtect.tip = this.$t('operations.turnOffDeleteProtect.tip')
				}
				if (!item.charge.chargeStatus) {
					turnOffDeleteProtect.tip = this.$t('eip.help.noChargeInfo');
				}
				operations.push(turnOffDeleteProtect);
			}
			// 删除实例
			const deleteOperate = {
				operateName: this.$t('operations.delete.name'),
				disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
					|| typeof item.charge.chargeStatus === 'undefined'
					|| item.status !== 'stopped'
					|| item.removeProtect === 'yes',
				value: 'delete',
				tip: ''
			};
			if (item.removeProtect === 'yes') {
				deleteOperate.tip = this.$t('operations.delete.tipWithRemoveProtect');
			}
			if (item.status !== 'stopped') {
				deleteOperate.tip = this.$t('operations.delete.tipWithStatus');
			}
			if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
				deleteOperate.tip = this.$t('operations.delete.tip');
			}
			if (!item.charge.chargeStatus) {
				deleteOperate.tip = this.$t('eip.help.noChargeInfo');
			}
			operations.push(deleteOperate);
			return operations;
		},
		clickOperate(item) {
			switch (item) {
				case 'rePassword':
					Pop.resetPassword(this, this.gridData);
					break;
				case 'repay':
					this.renewInstance(this.gridData.instanceId);
					break;
				case 'reInstall':
					this.sys_rein_dialog_visible = true;
					break;
				case 'open':
					Pop.vpcInstance_open(this, this.gridData, 'detail');
					break;
				case 'close':
					Pop.vpcInstance_close(this, this.gridData, 'detail');
					break;
				case 'restart':
					Pop.vpcInstace_restart(this, this.gridData, 'detail');
					break;
				case 'bandwidth':
					Pop.ops(PopStatus['BANDWIDTH'], this, this.gridData, 'detail')
					break;
				case 'sos':
					this.sosShow = true;
					break;
				case 'resetSos':
					this.resetSOSShow = true;
					break;
				case 'fixSos':
					this.fixSOSShow = true;
					break;
				case 'editTag':
					this.editTagDialogVisible = true;
					break;
				case 'delete':
					this.deleteVisible = true;
					break;
				case 'turnOnDeleteProtect':
					this.enableDeletionProtectionVisible = true;
					break;
				case 'turnOffDeleteProtect':
					this.disableDeletionProtectionVisible = true;
					break;
				default:
					break;
			}
		},
		renewInstance(id) {
			const params = {
				resourceId: id,
				region: this.gridData.region,
			};
			Ajax.get('/api/order/submitRenew', params)
				.then((res) => {
					const tempOrderId = res.data.tmpOrderId;
					window.location.href = `${this.Config.RENEW_CONSOLE_URL}/orderConfirmPageIp?requestId=${tempOrderId}&resourceType=cps`;
				});
		},
		openReConfirm(formInfo, rowInfo) {
			this.reSysForm = formInfo;
			this.reSystemInfo = rowInfo;
			this.sys_rein_confirm_dialog_visible = true;
		},
		sosFix() {
			if (this.gridData.keypairIdSos !== undefined) {
				this.sosShow = true;
			} else {
				this.fixSOSShow = true;
			}
		},
		sosReset() {
			this.resetSOSShow = true;
		},
		getSubnetDetailData() {
			const target = this;
			Ajax.get({
				action: '/getSubnet',
				param: {
					region: target.region,
					az: target.az,
				},
				success: (data) => {
					const subnetDetail = data.subnet;
					target.subnetDetailData = subnetDetail;
				}
			});
		},
		getHardwearMonitor() {
			// 硬件监控查询
			this.hardWareData = [];
			const params = {
				region: this.region,
				sn: this.sn
			};
			Ajax.get('/api/cps/describeInstanceStatus', params)
				.then((res) => {
					const data = res.data;
					if (this.gridData && this.gridData.cpsConfiguration && this.gridData.cpsConfiguration.deviceType) {
						this.hardWareData.push(
							{
								name: 'CPU',
								status: data.cpus
							},
							{
								name: this.$t('detail.text.memory'),
								status: data.mems
							},
							{
								name: this.$t('detail.text.hardDisk'),
								status: data.disks
							},
							{
								name: this.$t('detail.text.netCard'),
								status: data.nics
							},
							{
								name: this.$t('detail.text.power'),
								status: data.powerStatus
							},
							{
								name: this.$t('detail.text.other'),
								status: data.otherStatus
							},
						);
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
				});
		},
		// 获取实例的监控日志列表
		getMonitorLogs() {
			// 硬件监控查询
			this.loading = true;
			const params = {
				region: this.region,
				instanceId: this.instanceId,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
				sn: this.sn
			};
			Ajax.get('/api/cps/oob/listDeviceAlertLog', params)
				.then((res) => {
					this.loading = false;
					const data = res.data;
					if (data && data.list.length) {
						this.eventLogs = data.list;
						this.total = data.totalCount;
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		changeTab(tab) {
			this.hasMonitor = false;
			if (tab.name === 'hardWareMonitor') {
				const params = {
					instanceId: this.instanceId,
					region: this.region,
					sn: this.sn
				};
				this.getHardwearMonitor(params);
				this.getMonitorLogs(params)
			} else if (tab.name === 'performanceMonitor') {
				this.hasMonitor = true;
				let query = this.$route.query;
				query.tabName = 'performanceMonitor'
				this.$router.push({
					path: `${this.$route.path.replace(/\/performance/g, '')}/performance`,
					query: {
						...query,
						imageType: this.gridData.imageType
					}
				});
			}
		},
		jump_to_up() {
			this.$router.push({
				name: 'List',
				params: { region: this.region }
			});
		},
		updateServerData($msg = null) {
			this.clientToken = Normal.getClientToken();
			// 更新数据
			this.getServerData(false);
		},
		calPrice() {
			const target = this;
			const server_data = target.public_net_gridData[0].server_data;
			const params = {
				cmd: 3,
				resourceId: server_data.instanceId,
				region: server_data.region,
				timeUnit: 3,
				timeSpan: 12,
				bw: target.public_net_slider_value,
				count: 1,
				createType: CreateTypeConstant.BASIC,
				deviceType: server_data.deviceType,
				billingType: server_data.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION ? 3 : 1
			};
			Ajax.get({
				url: '/api/price',
				action: '/calculateTotalPrice',
				param: params,
				success: (data) => {
					target.totalFee = data.discountedTotalPrice;
					target.totalPrice = data.totalPrice;
					target.totalDiscount = data.totalDiscount;
				}
			});
		},

		public_net_confirm() {
			// 调整公网确认
			const server_data = this.public_net_gridData[0].server_data;
			if (this.public_net_slider_value < server_data.bandwidth) {
				this.$message.error(this.$t('detail.speechCraft.confirmNet'));
				return;
			}

			const target = this;
			// 创建临时订单
			const params = {
				orderType: 3,
				region: server_data.region,
				bw: this.public_net_slider_value,
				resourceId: server_data.instanceId,
				clientToken: this.clientToken,
				timestamps: this.clientToken,
			};
			Ajax.post('/api/cps/instances/modifyBandwidth', params)
				.then((res) => {
					const data = res.data;
					if (data.code) {
						if (data.code == '20701') {
							Pop.only_one(this);
							return false;
						}
						if (data.code == '20702') {
							Pop.repeat_order(this);
							return false;
						}
						if (data.code == '20703') {
							Pop.personal_buy(this);
							return false;
						}
					}
					if (data.tempOrderNumber) {
						const orderId = data.tempOrderNumber;
						if (orderId !== '' && orderId !== undefined) {
							window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
						}
					}
				});
		},
		getAvailableOs() {
			const server_data = this.sys_rein_gridData[0].server_data;
			this.getAvailableRaids(server_data.deviceType, server_data.region);
			Ajax.get({
				action: '/getAvailableOS',
				param: { region: server_data.region, deviceType: server_data.deviceType, imageType: this.selectedImageType },
				success: (data) => {
					const osTypes = {};
					this.customOsTypes = {};
					for (const i in data.oss) {
						const osTypeId = data.oss[i].osTypeId;
						const osType = data.oss[i].osType;
						const osName = data.oss[i].osName;
						const osVersion = data.oss[i].osVersion;
						if (!osTypes[osType]) {
							osTypes[osType] = [];
						}
						osTypes[osType].push({ osTypeId, osVersion, osName });
						if (osType !== 'Ubuntu') {
							if (this.customOsTypes[osType] === undefined) {
								this.customOsTypes[osType] = [];
							}
							this.customOsTypes[osType].push({ osTypeId, osName });
						}
					}
					this.osTypes = osTypes;
					this.standardOsTypes = $.extend(true, {}, this.osTypes);
					if (osTypes.CentOS) {
						this.selectedOS = 'CentOS';
					} else {
						this.selectedOS = data.oss[0].osType;
					}
					if (this.selectedImageType !== 'standard_app') {
						this.osTypes = $.extend(true, {}, this.standardOsTypes);
					} else {
						this.selectedOS = 'CentOS';
						this.osTypes = $.extend(true, {}, this.customOsTypes);
					}
				}
			});
		},
		selectApplication(name) {
			for (var i in this.selectedApplication) {
				if (name == this.selectedApplication[i].name) {
					this.selectedApplication.splice(i, 1);
					return;
				}
			}
			for (var i in this.applications) {
				if (name == this.applications[i].name) {
					this.selectedApplication.push({ name, version: this.applications[i].version });
					return;
				}
			}
		},
		getAvailableRaids(deviceType, region) {
			Ajax.get({
				action: '/getAvailableRaids',
				param: {
					deviceType,
					region
				},
				success: (data) => {
					const server_data = this.sys_rein_gridData[0].server_data;
					const raids = [];
					for (const i in data.raids) {
						// 系统盘raids
						if (data.raids[i].volumeType != 'system') {
							if (data.raids[i].raidType === 'NO RAID') {
								raids.splice(0, 0, data.raids[i]);
							} else {
								raids.push(data.raids[i]);
							}
						}
					}
					this.raids = raids;
					// 优化默认选择raid卡逻辑
					if (raids.length > 0) {
						this.selectedDataRaidId = server_data.dataRaidTypeId;
						this.selectedDataRaidType = server_data.dataRaidType;
					}
				}
			});
		},
		selectDataRaid(raidId, raidType) {
			this.selectedDataRaidId = raidId;
			this.selectedDataRaidType = raidType;
		},
		copyToClipboard() {
			this.copyHover = true;
		},
		failToCopy() {
			console.log('Failed to copy texts');
		},
		// 转化参数临时方案
		transformKey(value) {
			switch (value) {
				case this.$t('detail.text.shutdown'):
					return 'shutdown';
				case this.$t('detail.text.run'):
					return 'run';
				case this.$t('detail.text.error'):
					return 'error';
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getMonitorLogs();
		},

		handleCurrentChange(val) {
			this.currentPage = val;
			this.getMonitorLogs();
		},
	}
};
</script>

<style scoped>
/* 实例名称过长 .. 显示*/
.long-name {
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 100px;
	white-space: nowrap;
	float: left;
}

/*英文下换行  */
.english-word-wrap {
	word-break: keep-all !important;
}

/*图标不换行*/
.icon-nowrap {
	display: inline;
	white-space: nowrap;
}

/*调整图标的位置*/
.icon-position {
	margin-top: -5px;
	margin-left: 5px;
	display: inline;
}

.operate-select {
	width: 102px;
}

.my-jc-table-column {
	background-color: #ffffff !important;
}

th.my-jc-table-column {
	border-top: 1px solid #d9e1e9;
}

.my-jc-table-column .cell {
	background-color: transparent;
}


.my-status-success {
	color: #1bca69;
}

.my-status-success:before {
	background: #1bca69;
}

.my-status-danger {
	color: #ff3a3a;
}

.my-status-danger:before {
	background: #ff3a3a;
}

.mystatus-warning {
	color: #fab418;
}

.my-status-warning:before {
	background: #fab418;
}

.my-status-middle {
	color: #E066FF;
}

.my-status-middle:before {
	background: #E066FF;
}

.my-status-middle {
	color: #E066FF;
}

.my-status-middle:before {
	background: #E066FF;
}

.my-error-status:hover {
	text-decoration: underline;
	cursor: pointer;
}

.jc-dropdown-menu {
	padding: 0;
}

.pages i {
	color: #9d9d9d;
}

.pages a.firstpage i,
.pages a.lastpage i {
	background: transparent;
}

.jc-dropdown-menu__item.is-disabled {
	color: #999;
	background: #fff;
	cursor: not-allowed;
	pointer-events: all;
}

.jc-form-tip {
	display: none;
	position: absolute;
	background: #fff;
	border: 1px solid #d9d9d9;
	top: 0;
	line-height: 25PX;
	height: 25px;
	padding: 0 5px;
	white-space: nowrap;
	left: 0;
	margin: 0px;
	transform: translate(-105%, 20%);
}

.editdescription .description {
	overflow: hidden;
	max-width: 60%;
	white-space: nowrap;
	text-overflow: ellipsis;
	float: left;

}
</style>

<style lang="scss">
@import "~@/assets/scss/detailCommon.scss";
@import "style.scss";
</style>



// WEBPACK FOOTER //
// src/views/basicInstance/detail/Detail.vue